// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_gc","advertDetailServiceList__header":"c-p_ge","advertDetailServiceList__list":"c-p_gf"};